module.exports = __webpack_public_path__ + "static/social-media-image-8902ad7e1652f72aed3fc84af0e3c32c.png";